module.exports = __webpack_public_path__ + "img/img9.97ff71b7.png";